import React, { createContext, useState } from "react";
export const _LegendContext = createContext(undefined);
export const LegendProvider = ({ children }) => {
    const [legend, setLegend] = useState();
    return (React.createElement(_LegendContext.Provider, { value: [legend, setLegend] }, children));
};
